<template>
	<div style="min-height: 100%; width: 100%; background-color: black;">
		<div class="landing-page-header bg-min-height">
			<!-- 
			<transition-group name="blur" tag="div">
				<div v-show="currentSrc === null" class="placeholder blur-transition bg-img" key="placeholder"></div>
				<canvas v-show="currentSrc === loResSrc" key="canvas" class="blur-transition bg-img"></canvas>
				<img v-show="currentSrc === hiResSrc" :src="hiResSrc" key="image" class="blur-transition bg-img"></img>
			</transition-group> -->
			<div :class="{'background-image': true, 'background-image-1': true, 'transparent': (backgroundImageIndex !== 0 || !imageLoaded)}">
			</div>
			<div :class="{'background-image': true, 'background-image-2': true, 'transparent': backgroundImageIndex !== 1}">
			</div>
			<div :class="{'background-image': true, 'background-image-3': true, 'transparent': backgroundImageIndex !== 2}">
			</div>
			<div class="landing-page-header__gradient" style="z-index: 1;">
				<v-container class="ma-0" :style="getLandingPageContainerStyle">
					<v-layout row align-center style="height: 100%;">
						<v-flex lg9 class="landing-page-text-container" :style="getTextContainerStyle">
							<h2>POP-UP</h2>
							<h1>COWORKING</h1>
							<p>and other curated professional experiences...</p>
							<h3>{{dynamicTextStart}}<span v-if="dynamicTextStart">&nbsp;</span></h3><h4>{{dynamicTextEnd}}<span style="font-size: 1.1em; position: relative; top: -3px;">{{getFlashingCaret}}</span>&nbsp;</h4>
						</v-flex>
						<!-- <img
							class="landing-page-header__logo"
							src="//wrkprty.imgix.net/backgrounds/homepage-logo.png"
							alt="WRKPRTY"
						/> -->
						<!-- <v-btn
							class="btn-min-height btn-blue mt-5 btn-large elevation-2 linkedin-login-btn"
							dark
							@click="loginRedirectLinkedin"
							:loading="loginRedirectingLinkedin"
							ref="loginLinkedinButton"
						>
							Sign in with LinkedIn
						</v-btn>
						<v-btn
							@click="setAuthModalOpen(true)"
						>
							More options
						</v-btn>
						<v-btn class="btn-min-height" flat dark @click="WhyLinkedinModal = true">
							Why LinkedIn?
						</v-btn> -->
					</v-layout>
					<div class="landing-page__bottom-right" v-if="!isMobile">
						<p>Join and experience the <span style="font-weight: bold; color: #DDD;">wrkprty</span> community today.</p>
						<v-btn @click="loginModal = true" flat class="landing-page__bottom-right--button"><p>Get Started</p></v-btn>
					</div>
					<div class="landing-page__bottom-container--mobile" v-else>
						<p>wrkprty</p>
						<span class="landing-page__bottom-container__button-container">
							<v-btn flat @click="loginModal = true" class="landing-page__bottom-container-button">Join</v-btn>
							<div class="landing-page__bottom-container__vertical-divider"></div>
							<v-btn flat @click="loginModal = true" class="landing-page__bottom-container-button">Sign in</v-btn>
						</span>
					</div>
				</v-container>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import { makeid } from '~/store/util/util'
export default {
	name: 'home',
	data () {
		return {
			loginRedirectingLinkedin: false,
			loginRedirectingFacebook: false,
			linkedin_oauth_token: '',
			showWhyLinkedinModal: false,
			dynamicTextListIndex: 0,
			dynamicTextList: [
				'in-HOMES.',
				'in-COWORK SPACES.',
				'at-the PARK.',
				'on-BOATS.',
				'in-RESTAURANTS.',
				'in-ART GALLERIES.',
				'-any time, any place.'
			],
			dynamicTextIndex: 0,
			dynamicTextDirection: -1,
			dynamicTextSpeed: 70,
			dynamicTextWaitTime: 700,
			caretFlashSpeed: 500,
			flashingCaretVisible: false,
			backgroundImageIndex: 0,
			imageSpeed: 9000,
			imageLoaded: false,
			imgSrc: 'https://wrkprty.imgix.net/backgrounds/wrkprty-home-1.jpg'
		}
	},
	mounted () {
		this.dynamicTextIndex = this.dynamicTextList[0].length
		setTimeout(this.updateDynamicText, this.dynamicTextWaitTime)
		setTimeout(this.updateFlashingCaret, this.caretFlashSpeed)
		setTimeout(this.updateBackgroundImage, this.imageSpeed)
		this.handleImageLoading()
	},
	methods: {
		...mapActions([
			'setMobileNavActive',
			'setModalOpen',
			'setAuthRedirect',
			'setAuthModalOpen',
			'signUserInLinkedin',
			'setUserSocial',
			'setToken',
		]),
		handleImageLoading () {
			var img, that
			img = new Image()
			that = this
			img.onload = function(){
				that.imageLoaded = true
			}
			img.src = that.imgSrc
		},
		updateFlashingCaret () {
			if (this.dynamicTextIndex === this.dynamicTextList[this.dynamicTextListIndex].length) {	
				this.flashingCaretVisible = !this.flashingCaretVisible
			} else {
				this.flashingCaretVisible = true
			}
			setTimeout(this.updateFlashingCaret, this.caretFlashSpeed)
		},
		updateBackgroundImage () {
			this.backgroundImageIndex = (this.backgroundImageIndex + 1) % 3
			setTimeout(this.updateBackgroundImage, this.imageSpeed)
		},
		updateDynamicText () {
			if ((this.dynamicTextIndex === 0) && (this.dynamicTextDirection === -1)) {
				this.dynamicTextListIndex += 1
				this.dynamicTextListIndex = this.dynamicTextListIndex % this.dynamicTextList.length
				this.dynamicTextDirection = 1
				setTimeout(this.updateDynamicText, this.dynamicTextSpeed)
			} else if ((this.dynamicTextIndex === this.dynamicTextList[this.dynamicTextListIndex].length) && (this.dynamicTextDirection === 1)) {
				this.dynamicTextDirection = -1
				setTimeout(this.updateDynamicText, this.dynamicTextWaitTime)
			} else {
				this.dynamicTextIndex += this.dynamicTextDirection
				setTimeout(this.updateDynamicText, this.dynamicTextSpeed)
			}
		},
		loginFacebook() {
			this.loginRedirectingFacebook = true
			this.$auth.authenticate('facebook').then((response) => {
				this.loginRedirectingFacebook = false
				this.setToken(response.data.token)
				this.setUserSocial(response.data.user)
			})
		},
		loginRedirectLinkedin() {
			this.loginRedirectingLinkedin = true
			const userLoginHash = makeid(24)
			window.localStorage.setItem('login_hash', userLoginHash)
			axios({
				method: 'get',
				url: '/rest-auth/linkedin/requestToken/',
				params: {
					user_hash: userLoginHash
				},
				withCredentials: false,
				headers: {
					'Content-Type': 'application/json'
				},
				transformRequest: (data, headers) => {
					delete headers['Authorization']
					delete headers.common['Authorization']
					return data
				}
			})
				.then(response => {
					this.linkedin_oauth_token = response.data
					// window.location.href = this.linkedInAuthUrl
					// this.loginRedirectingLinkedin = false
					window.location = this.linkedInAuthUrl
				})
				.catch(error => {
					this.loginRedirectingLinkedin = false
					console.error('linkedin error')
					console.error(error)
				})
		}
	},
	computed: {
		...mapGetters(['getVisitorLocation', 'getModalProp']),
		getImages () {
			return [
				'https://wrkprty.imgix.net/backgrounds/wrkprty-home-1.jpg',
				'https://wrkprty.imgix.net/backgrounds/wrkprty-home-2.jpg',
				'https://wrkprty.imgix.net/backgrounds/wrkprty-home-3.jpg'
			]
		},
		getFlashingCaret () {
			if (this.flashingCaretVisible) {
				return '|'
			} else {
				return ' '
			}
		},
		linkedInAuthUrl() {
			return (
				'https://www.linkedin.com/uas/oauth/authenticate?oauth_token=' +
				this.linkedin_oauth_token +
				'&state='
			)
		},
		getTextContainerStyle () {
			if (this.isMobile) {
				return {
					'margin-bottom': '10vh'
				}
			}
		},
		dynamicText () {
			return this.dynamicTextList[this.dynamicTextListIndex].substring(0, this.dynamicTextIndex)
		},
		dynamicTextStart() {
			return this.dynamicText.split('-')[0]
		},
		dynamicTextEnd() {
			let sp = this.dynamicText.split('-')
			if (sp.length > 1) {
				return sp[1]
			} else {
				return ''
			}
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		},
		getLandingPageContainerStyle () {
			if (this.isMobile) {
				return {
					'height': '100vh'
				}
			} else {
				return {
					'height': '100%'
				}
			}
		},
		WhyLinkedinModal: {
			get() {
				return this.getModalProp('whyLinkedinModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'whyLinkedinModal', value: val })
			}
		},
		loginModal: {
			get() {
				return this.getAuthModalOpen
			}, set(val) {
				this.setAuthModalOpen(val)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.placeholder {
	height: 100vh;
	width: 100vw;
	background-color: rgba(50, 50, 50, 1)
}
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
.flashing-caret {
	font-size: 1.0em;
	color: white;
}
.transparent {
	opacity: 0;
}
img, canvas, .placeholder {
	height: 600px;
	width: 900px;
	position: absolute;
}
.placeholder {
	background-color: rgba(0,0,0,.05);
}
canvas {
	filter: blur(10px);
}
.blur-transition {
	transition: opacity linear .4s 0s;
	opacity: 1;
}
.blur-enter, .blur-leave {
	opacity: 0;
}
.bg-img {
	z-index: 1;
	height: 100vh;
	width: 100vw;
	position: absolute;
	top: 0;
	left: 0;
	max-height: 100%;
	max-width: 100%;
	overflow: hidden;
}
.background-image {
	z-index: 1;
	height: 100vh;
	width: 100vw;
	position: absolute;
	top: 0;
	left: 0;
	max-height: 100%;
	max-width: 100%;
	overflow: hidden;
	-webkit-transition: opacity 2s ease-in-out;
	-moz-transition: opacity 2s ease-in-out;
	-o-transition: opacity 2s ease-in-out;
	transition: opacity 2s ease-in-out;
}
.background-image-1 {
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	background-image: url('https://wrkprty.imgix.net/backgrounds/wrkprty-home-1.jpg');
}
.background-image-2 {
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	background-image: url('https://wrkprty.imgix.net/backgrounds/wrkprty-home-2.jpg');
}
.background-image-3 {
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	background-image: url('https://wrkprty.imgix.net/backgrounds/wrkprty-home-3.jpg');
}
.landing-page-carousel {
	z-index: 1;
	height: 100vh;
	.carousel-image {
		height: 100vh;
	}
	.carousel-image.active {
		z-index: 2;
	}
	.jumbotron__wrapper {
		position: absolute;
		top: 0;
		left: 0;
		max-width: 100%;
		max-height: 100%;
		overflow: hidden;
	}
}
.landing-page-header {
	// background: url('//wrkprty.imgix.net/backgrounds/landing.jpg?q=70&auto=format')
	// 	no-repeat center center;
	// -webkit-background-size: cover;
	// -moz-background-size: cover;
	// -o-background-size: cover;
	// background-size: cover;
	position: absolute;
	left: 0;
	top: 0;

	width: 100vw;
	height: 100%;
	&__gradient {
		position: absolute;
		top: 0px;
		left: 0px;
		opacity: 0.99;
		z-index: 2;
		width: 100%;
		height: 100%;
		background: linear-gradient(
			to bottom,
			rgba(0, 0, 0, 0.35) 0%,
			rgba(0, 0, 0, 0) 22%,
			rgba(0, 0, 0, 0) 65%,
			rgba(12, 12, 12, 0.5) 85%,
			rgba(12, 12, 12, 1) 98%
		);
	}
}

.landing-page__bottom-container--mobile {
	position: fixed;
	bottom: 0;
	left: 0;
	height: 75px;
	width: 100vw;
	// background-color: rgba(255,255,255,0.25);
	// background-color: rgba(125,125,125,0.06);
	// border-bottom: 1px solid #AAA;
	// box-shadow: 0 15px 40px #AAA;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 10px 0 27px;
	p {
		font-family: 'Quantico';
		margin-bottom: 2px;
		display: inline;
		color: #7A7A7A;
		font-weight: bolder;
		font-size: 1.5em;
		letter-spacing: 0.5px;
	}
}

.landing-page__bottom-container__button-container {
	display: flex;
	justify-content: center;
	align-items: center;
}

.landing-page__bottom-container-button {
	font-weight: 100!important;
	font-family: Nunito, sans-serif;
	font-size: 1.3em;
	color: #EEE!important;
	width: 60px;
	min-width: 70px;
}

.landing-page__bottom-container__vertical-divider {
	display: inline;
	margin: 0;
	width: 1px;
	height: 19px;
	border-left: 1px solid #AAA;
	margin-bottom: 1px;
	margin-right: 8px;
}

.landing-page__bottom-right {
	position: absolute;
	bottom: 50px;
	right: 65px;
	display: flex;
	align-items: center;
	p {
		margin: 0 10px 0 0;
		color: #AAA;
		font-family: 'Nunito', sans-serif;
		font-weight: 100;
	}
	.landing-page__bottom-right--button {
		color: #CCC;
		border: 1px solid #CCC;
		p {
			color: #CCC;
			font-family: 'Nunito', sans-serif;
			font-weight: 300;
		}
		height: 50px;
		min-height: 50px;
		width: 160px;
		min-width: 160px;
		border-radius: 0;
	}
}

.landing-page-text-container {
	color: #EEE;
	padding-left: 100px;
	padding-top: 5vh;
	font-size: 1.3em;

	h1 {
		margin: 0!important;
		line-height: 1.1em;
		font-size: 4.0em;
		font-weight: 200;
		font-family: 'Nunito', sans-serif;
	}
	h2 {
		margin-bottom: 10px;
		font-weight: 100;
		font-family: 'Nunito', sans-serif;
		font-size: 2.0em;
	}
	p {
		font-family: 'Nunito', sans-serif;
		font-weight: 100;
		margin-bottom: 5px;
		color: #EEE;
	}
	h3 {
		font-weight: 100;
		font-family: 'Nunito', sans-serif;
		display: inline;
	}
	h4 {
		font-weight: 100;
		font-family: 'Nunito', sans-serif;
		display: inline;
		font-size: 2.0em;
	}
}

.landing-page-header__logo {
	width: 45vw;
}

@media screen and (max-width: 900px) {
	.landing-page-text-container {
		padding-left: 50px;
	}
}


@media screen and (max-width: 600px) {
	.landing-page-header__logo {
		width: 65vw;
	}

	.landing-page-text-container {
		color: #EEE;
		padding-left: 0;
		padding-bottom: 0vh;
		padding-top: 5vh;
		font-size: 1.0em;

		h1 {
			margin: 0!important;
			line-height: 1.1em;
			font-size: 3.5em;
			font-weight: 200;
			font-family: 'Nunito', sans-serif;
		}
		h2 {
			margin-bottom: 10px;
			font-weight: 100;
			font-family: 'Nunito', sans-serif;
			font-size: 2.0em;
		}
		p {
			font-family: 'Nunito', sans-serif;
			font-weight: 100;
			color: #EEE;
		}
		h3 {
			font-weight: 100;
			font-family: 'Nunito', sans-serif;
			display: inline;
		}
		h4 {
			font-weight: 100;
			font-family: 'Nunito', sans-serif;
			display: inline;
			font-size: 2.0em;
		}
	}
}

@media screen and (max-height: 450px) {
	.landing-page-text-container {
		font-size: 0.8em;
	}	
}

@media screen and (max-width: 400px) {
	.landing-page-text-container {
		font-size: 0.7em;
	}
}

@media screen and (min-width: 1200px) {
	.landing-page-text-container {
		font-size: 1.6em;
	}
}

.landing-page-gradient-foreground {
	z-index: 1;

	background: linear-gradient(
		to bottom,
		rgba(0, 0, 0, 0) 0%,
		rgba(150, 150, 150, 0) 60%,
		rgba(12, 12, 12, 0.2) 85%,
		rgba(12, 12, 12, 1) 100%
	);

	pointer-events: none;

	position: absolute;
	top: 0px;
	left: 0px;
	width: 100vw;
	height: 100vh;
}

.card-style {
	position: absolute;
	top: 0px;
	width: 100%;
	background-color: black !important;
}
.landing-card {
	background-color: black !important;
	background: transparent !important;
}

.card__media__background {
	/*opacity: 0.7;*/
}

.card-background-image > div:nth-child(1) {
	/*opacity: 0.7;*/
}

.btn-min-height {
	min-height: 35px;
}

.bg-min-height {
	height: 100vh;
	// min-height: 600px;
}
// @media screen and (max-height: 600px) and (max-width: 600px) {
// 	.bg-min-height {
// 		min-height: 600px;
// 	}
// }
</style>
